export const environment = {
  production: true,
  type: 'dev',
  backEndUrl: '/api',
  clientUrl: 'http://localhost',

  google: {
    key: 'AIzaSyDBENIU_tmbHE1id_lHuawhTLYpWq93opk'
  },

  reCaptcha: {
    siteKey: '6LdrzbMZAAAAAKlwy7Rl3kfoDraDjtnAv5SaZELU',
    secretKey: '6LdrzbMZAAAAAK0isP4JBD0nxKSYEWMcAy8ChjRb'
  },

  firebase: {
    apiKey: "AIzaSyABLkFax2sGMiXbB0yLdoaCENMbJXN9Mcw",
    authDomain: "corona-tower.firebaseapp.com",
    databaseURL: "https://corona-tower.firebaseio.com",
    projectId: "corona-tower",
    storageBucket: "corona-tower.appspot.com",
    messagingSenderId: "576047039642",
    appId: "1:576047039642:web:fcae042cb5997bd7df0b23",
    measurementId: "G-HCQ3DJ8V8F"
  },

  maps: {
    here: "KPRl6-gQfUhKY1v7yZcN3q0v2Q-iRDYt_71WIz_flMg",
    mapBox: "pk.eyJ1IjoicmVkb25iZWp0dWxsYWh1IiwiYSI6ImNram9kOGYxaDJ3OHMycW83NDFrMzhpYTgifQ.WasQUKYJTboaYy_NOW4UYA"
  }

};
